import { Upload } from 'lucide-react';

import { Button } from '@/components/ui/button';
import { DialogHeader, DialogTitle } from '@/components/ui/dialog';

import { useUploadDocumentMutation } from '@/query/knowledge.query';

import { useDocumentUpload } from '../hooks/use-document-upload';

import { DocumentUploadTabs } from './document-upload-tabs';

import { useKnowledgeModalsStore } from '@/store/knowledge-modals.store';
import useModalStore from '@/store/modal.store';

export function AddDocumentDialog() {
  const knowledgeBase = useKnowledgeModalsStore(state => state.selectedKnowledgeBase);
  const { closeModal } = useModalStore();

  const handleClose = () => {
    reset();
    closeModal();
  };

  const uploadDocumentMutation = useUploadDocumentMutation({
    onSuccess: () => {
      handleClose();
    },
  });

  const { isSubmitDisabled, handleFileSelect, handleSubmit, reset } = useDocumentUpload({
    onSuccess: async (file: File) => {
      if (!knowledgeBase) return;
      await uploadDocumentMutation.mutateAsync({ kbId: knowledgeBase.kb_id, file });
    },
  });

  const handleAddDocument = async () => {
    await handleSubmit();
  };

  return (
    <>
      <DialogHeader>
        <DialogTitle className="text-lg font-semibold flex items-center gap-2">
          <Upload className="h-5 w-5" />
          Add Document to {knowledgeBase?.name}
        </DialogTitle>
      </DialogHeader>

      <div className="space-y-4">
        <DocumentUploadTabs onFileSelect={handleFileSelect} />

        <div className="flex justify-end gap-2 pt-2">
          <Button
            variant="outline"
            onClick={handleClose}
            disabled={uploadDocumentMutation.isPending}
            className="px-3"
          >
            Cancel
          </Button>
          <Button
            disabled={isSubmitDisabled || uploadDocumentMutation.isPending}
            type="button"
            onClick={handleAddDocument}
            className="px-3"
          >
            {uploadDocumentMutation.isPending ? (
              <>
                <div className="w-4 h-4 border-2 border-primary-foreground border-t-transparent rounded-full animate-spin mr-2" />
                Uploading
              </>
            ) : (
              <span>Upload Document</span>
            )}
          </Button>
        </div>
      </div>
    </>
  );
}
